import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import {
  getBaseProduct,
  getBaseProductRollerNight,
} from '../../../helpers/getBaseProduct';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getFormatedPrice } from '../../../helpers/getFormatedPrice';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { isRollerDayNight } from '../../../helpers/isRollerDayNight';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
// import { Caption } from '../../Common/Caption';
import { Extra } from '../../Common/Extra';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorImageItem,
  // SelectorItem,
} from '../../Common/Selector';
// import { SectionContent } from './SectionContent';

type OnClick = (
  lightGuards: number | 'no',
  lightGuardPrice: number,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  text-align: center;

  @media (min-width: 1441px) {
    padding: 0px 52px;
  }
  @media (max-width: 1440px) {
    padding: 0px 25px;
  }
`;

const Caption = styled.div`
  text-align: center;
  font: normal normal 300 14px/20px Lato;
  letter-spacing: 0.28px;
  color: #242325;
  max-width: 470px;
  margin: 7px auto 0px;
  min-height: 20px;

  @media (max-width: 1440px) {
    margin-top: 2px;
  }
  @media (max-width: 767px) {
    font-size: var(--bs-xs-font-size);
  }
`;

const onClick: OnClick = (lightGuards, lightGuardPrice, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      lightGuards,
      lightGuardPrice,
    },
  });
};

export const LightGuards = () => {
  const [state, send] = useService(productBuilderMachine);
  let baseProduct;

  if (isRollerDayNight(state.context)) {
    baseProduct = getBaseProductRollerNight(state.context);
  } else {
    baseProduct = getBaseProduct(state.context);
  }

  const lightGuardsTypes = baseProduct
    ? baseProduct.metafields.light_guard || []
    : [];
  const {
    lightGuards: lightGuardsAddonProducts,
    custom: { lightGuards, measurements },
  } = state.context;

  if (isCurrentState('lightGuards', state) && lightGuardsTypes.length === 0) {
    throwError(state);
  }

  let variantIndex = 0;
  let lightGuardsVariantId = 0;
  let lightGuardsVariantPrice = 0;

  if (isCurrentState('lightGuards', state)) {
    const height = measurements.split('x')[1];
    lightGuardsAddonProducts[0].variants.map((variant, index) => {
      const lightGuardsHeight = variant.title.split('m')[0];
      if (parseInt(height, 10) < parseInt(lightGuardsHeight, 10) && index === 0)
        variantIndex = index;
      if (parseInt(height, 10) > parseInt(lightGuardsHeight, 10)) {
        return (variantIndex =
          index !== lightGuardsAddonProducts[0].variants.length - 1
            ? variantIndex + 1
            : index);
      }
    });

    lightGuardsVariantId = lightGuardsAddonProducts[0].variants[variantIndex].id;
    lightGuardsVariantPrice = lightGuardsAddonProducts[0].variants[variantIndex].price;
  }
  const productType = getBaseProductType(state.context);

  // const getCaption =
  //   productType === 'Roller Blind'
  //     ? `Blocks the light between the side of the window and the blind fabric and at the top of the roller mechanism`
  //     : `Light Guards help minimise light leakage on the sides of the blinds only, but they will not block 100% of light leakage on the sides top or bottom.`;

  return (
    <Wrapper>
      <Heading>Light guards</Heading>
      <Caption>Light Guards help minimise light leakage on the sides of the blinds only, but they will not block 100% of light leakage on the sides top or bottom.</Caption>
      <Selector isSlider={true}>
        <SelectorImageItem
          key={lightGuardsVariantId}
          title="Light Guards"
          isSelected={lightGuards === lightGuardsVariantId}
          showIcon={
            getProductStateConfig(productType, 'lightGuards', 'Yes').showIcon
          }
          Icon={getProductStateConfig(productType, 'lightGuards', 'Yes').Icon}
          onClick={onClick(lightGuardsVariantId, lightGuardsVariantPrice, send)}
        >
          Light Guards{' '}
          <Extra> + {getFormatedPrice(lightGuardsVariantPrice)} </Extra>
        </SelectorImageItem>

        <SelectorImageItem
          key="no"
          title="No Light Guards"
          isSelected={lightGuards === 'no'}
          showIcon={
            getProductStateConfig(productType, 'lightGuards', 'No').showIcon
          }
          Icon={getProductStateConfig(productType, 'lightGuards', 'No').Icon}
          onClick={onClick('no', 0, send)}
        >
          No, thanks
        </SelectorImageItem>
      </Selector>
    </Wrapper>
  );
};
